import React from 'react'
import PropTypes from 'prop-types'
import { Button, Tooltip } from 'reactstrap'
import { FaTable } from 'react-icons/lib/fa'
import styles from './TableSlatePlugin.scss'

class TableButton extends React.Component {
  constructor (props) {
    super(props)

    this.uid = Date.now()

    this.state = {
      tooltipOpen: false
    }
  }

  toggle = () => {
    this.setState({
      tooltipOpen: !this.state.tooltipOpen
    })
  }

  render () {
    const { hasTable, actions, state: editorState, onChange, style, noTooltip } = this.props
    const isActive = hasTable(editorState)

    const customStyle = {}

    return (
      <Button
        id={'TableButton' + this.uid}
        style={{...style, ...customStyle}}
        onClick={e => onChange(actions.onInsertTable(e, editorState))}
        color={isActive ? 'primary' : 'secondary'}
        className={styles.TableButton}
      > <FaTable />
        {
          !noTooltip &&
          <Tooltip placement='top' isOpen={this.state.tooltipOpen} target={'TableButton' + this.uid} toggle={this.toggle}>
            Table
          </Tooltip>
        }
      </Button>
    )
  }
}

TableButton.propTypes = {
  hasTable: PropTypes.func,
  actions: PropTypes.object,
  state: PropTypes.object.isRequired,
  onChange: PropTypes.func.isRequired,
  noTooltip: PropTypes.bool,
  style: PropTypes.object
}

export default TableButton



// WEBPACK FOOTER //
// ./src/components/DeepTableSlatePlugin/TableButton.js